import { useQuery } from '@tanstack/react-query';
import { useTacticHooks } from '../../providers/TacticHooksProvider';
import { GetCalendarParams } from '@gettactic/api';

export function useMyCalendar(params: GetCalendarParams & {
    enabled?: boolean;
}) {
  const { api } = useTacticHooks();
  return useQuery({
    queryKey: ['my-calendar', params.date, params.tz, params.user_id],

    queryFn: async () => {
      const res = await api.client.myCalendar.getCalendar(params);
      return res.result;
    },

    enabled: !!params.tz && !!params.enabled
  });
}
